import _ from 'underscore';
/**
 * Function to check if a direct transition to another step is allowed
 *
 * @param {Object} flowModel - the ordered set of steps in the flow
 * @param {Object} currentStep - the current step in the flow
 * @param {Object} targetStep
 * @returns {Boolean}
 */
export default function checkIfTransitionAllowed(flowModel, currentStep, targetStep) {
    var currentStepIndex = _.findIndex(flowModel.steps, {
        name: currentStep.name
    });
    var targetStepIndex = _.findIndex(flowModel.steps, {
        name: targetStep.name
    });
    // only allow going back in the wizard if the steps are part of the same flow. This lets us move forward and backward on the same level in the UI.
    if (flowModel.steps[currentStepIndex].data().isInOrPastSubflow === true && flowModel.steps[targetStepIndex].data().isInOrPastSubflow === true) {
        return true;
    }
    return currentStepIndex >= targetStepIndex;
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/common/config/EndorsementJumpToStepCheck.js
// module id = 335
// module chunks = 0